import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './helpers/initFA';
import App from './App';
import FiltersProvider from './providers/FiltersProvider';
import AuthProvider from './contexts/AuthContext';
import WorkspaceProvider from './contexts/WorkspaceContext';
import { AppConfigProvider } from './contexts/AppConfigContext';
import reportWebVitals from './reportWebVitals';

const isBrowserExtensionError = (value) =>
  String(value || "").startsWith("chrome-extension://") ||
  String(value || "").includes("chrome-extension://");

window.addEventListener("error", (event) => {
  if (
    isBrowserExtensionError(event?.filename) ||
    isBrowserExtensionError(event?.error?.stack)
  ) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }
}, true);

window.addEventListener("unhandledrejection", (event) => {
  if (isBrowserExtensionError(event?.reason?.stack) || isBrowserExtensionError(event?.reason?.message)) {
    event.preventDefault();
  }
});

try {
  const reactDomModule = require("react-dom");
  if (reactDomModule && typeof reactDomModule.findDOMNode !== "function") {
    reactDomModule.findDOMNode = (target) =>
      target?.current || target?.editor?.root || target?.root || target || null;
  }
} catch (error) {
  // If react-dom can't be required here, react-quill will fall back to its
  // native behavior in environments that still provide findDOMNode.
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <WorkspaceProvider>
        <AppConfigProvider>
          <FiltersProvider>
            <App />
          </FiltersProvider>
        </AppConfigProvider>
      </WorkspaceProvider>
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
